// extracted by mini-css-extract-plugin
export default {"content":"ExpandableTextArea_content__SJ2-5","subtitle":"ExpandableTextArea_subtitle__Npo8a","text":"ExpandableTextArea_text__KEGUT","field":"ExpandableTextArea_field__-Ab6I"};